export default __webpack_public_path__ + "static/srikant-1b913556532b0227a9fe8ed0767a5b4f.jpeg";